// ===================================
// TRENCH QUEST - Token Price Service
// Fetches real-time Solana token prices from DexScreener API
// ===================================

const DEXSCREENER_API = 'https://api.dexscreener.com/latest/dex/tokens'

// All Solana token mint addresses used in the game
const KNOWN_MINTS: Record<string, string> = {
  // Stables
  SOL: 'So11111111111111111111111111111111111111112',
  USDC: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  USDT: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
  // Blue chips
  JUP: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN',
  RAY: '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R',
  PYTH: 'HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3',
  JTO: 'jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL',
  RNDR: 'rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof',
  HNT: 'hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux',
  W: '85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ',
  // Mid caps
  BONK: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263',
  WIF: 'EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm',
  PENGU: '2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv',
  ORCA: 'orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE',
  MNGO: 'MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac',
  MOBILE: 'mb1eu7TzEc71KxDpsmsKoucSSuuo6KWzI20NZRd8fZku',
  SAMO: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU',
  DRIFT: 'DriFtupJYLTosbwoN8koMbEYSx54aFAVLddWsbksjwg7',
  MSOL: 'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So',
  BSOL: 'bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1',
  // Degen
  FARTCOIN: '9BB6NFEcjBCtnNLFko2FqVQBq8HHM13kCyYcdQbgpump',
  GOAT: 'CzLSujWBLFsSjncfkh59rUFqvafWcY5tzedWJSuypump',
  POPCAT: '7GCihgDB8fe6KNjn2MYtkzZcRjQy3t9GHdC8uHYmW2hr',
  MEW: 'MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5',
  MOTHER: '3S8qX1MsMqRbiwKg2cQyx7nis1oHMgaCuc9c4VfvVdPN',
  TRUMP: '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN',
  AI16Z: 'HeLp6NuQkmYB4pYWo2zYs22mESHXPQYzXbB8n4V98jwC',
  SLERF: '7BgBvyjrZX1YKz4oh9mjb8ZScatkkwb8DzFx7LoiVkM3',
  BOME: 'ukHH6c7mMyiWCf6HER98iDqsisFC3M6CKWBKN4HLqFW',
  WEN: 'WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk',
  PONKE: '5z3EqYQo9HiCEs3R84RCDMu2n7anpDMxRhdK8PSWmrRC',
  MOODENG: 'ED5nyyWEzpPPiWimP8vYm7sD7TD3LAt3Q3gRTWHzPJBY',
  PNUT: '2qEHjDLDLbuBgRYvsxhc5D6uDWAivNFZGan56P1tpump',
  ORE: 'oreoU2P8bN6jkk3jbaiVxYnG1dCXcYxwhwyK9jSybcp',
  TUNA: 'TUNAfXDZEdQizTMTh3uEvNvYqJmqFHZbEJt8joP4cyx',
  MYRO: 'HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4',
  GIGA: '63LfDmNb3MQ8mw9MtZ2To9bEA2M71kZUUGq5tiJxcqj9',
  ZEREBRO: '8x5VqbHA8D7NkD52uNuS5nnt3PwA8pLD34ymskeSo2Wn',
  GRIFFAIN: 'KENJSUYLASHUMfHyy5o4Hp2FdNqZg1AsUPhfH2kYvEP',
  ACT: 'GJAFwWjJ3vnTsrQVabjBVK2TYB1YtRCQXRDfDgUnpump',
  CHILLGUY: 'Df6yfrKC8kZE3KNkrHERKzAetSxbrWeniQfyJY4Jpump',
  LOCKIN: '8Ki8DpuWNxu9VsS3kQbarsCWMcFGWkzzA8pUPto9zBd5',
  DADDY: '4Cnk9EPnW5ixfLZatCPJjDB1PUtcRpVVgTQukm9epump',
  BRETT: 'DxtssVdyYe4wWE5f5zEgx2NqtDFbVL3ABGY62WCycHWg',
  SPX: 'J3NKxxXZcnNiMjKw9hYb2K4LUxgwB6t1FtPtQVsv3KFr',
  TREMP: 'FU1q8vJpZNUrmqsciSjp8bAKKidGsLmouB8CBdf8TKQv',
  COST: 'Av6qVigkb7USQyPXJkUvAEm4f599WTRvd75PUWBA9eNm',
  // Ultra degen
  VINE: '6AJcP7wuLwmRYLBNbi825wgguaPsWzPBEHcHndpRpump',
  WOJAK: 'H3XMGj72YCNPSjZm82NFE5eYUQHckemqpUidVrJP3787',
  RETARDIO: '6ogzHhzdrQr9Pgv6hZ2MNze7UrzBMAFyBBWUYp1Fhitx',
  SIGMA: '5SVG3T9CNQsm2kEwzbRq6hASqh1oGfjqTtLXYUibpump',
  BODEN: '3psH1Mj1f7yUfaD5gh6Zj7epE8hhrMkMETgv5TshQA4o',
  FWOG: 'A8C3xuqscfmyLrte3VmTqrAq8kgMASius9AFNANwpump',
}

/**
 * DexScreener pair data (simplified)
 */
interface DexScreenerPair {
  chainId: string
  baseToken: { address: string; symbol: string }
  quoteToken: { address: string; symbol: string }
  priceUsd: string | null
  volume: { h24: number }
}

/**
 * Kept for backwards compatibility with imports
 */
export interface JupiterTokenData {
  address: string
  name: string
  symbol: string
  decimals: number
  logoURI?: string
  daily_volume?: number
}

export interface JupiterPriceData {
  id: string
  type: string
  price: string
}

/**
 * Fetch prices from DexScreener for a batch of mint addresses.
 * DexScreener supports comma-separated addresses in one call.
 * Returns map of address -> USD price.
 */
async function fetchDexScreenerPrices(addresses: string[]): Promise<Record<string, number>> {
  const prices: Record<string, number> = {}
  if (addresses.length === 0) return prices

  // DexScreener can handle batches but URLs have length limits, so chunk to ~30 at a time
  const chunkSize = 30
  for (let i = 0; i < addresses.length; i += chunkSize) {
    const chunk = addresses.slice(i, i + chunkSize)
    try {
      const response = await fetch(
        DEXSCREENER_API + '/' + chunk.join(',')
      )

      if (!response.ok) {
        console.error('[DexScreener] API error:', response.status)
        continue
      }

      const data = await response.json()
      const pairs: DexScreenerPair[] = data.pairs || []

      // Group pairs by base token address, filter to Solana only
      const bestPrices: Record<string, { price: number; volume: number }> = {}

      for (const pair of pairs) {
        if (pair.chainId !== 'solana' || !pair.priceUsd) continue

        const price = parseFloat(pair.priceUsd)
        if (isNaN(price) || price <= 0) continue

        const addr = pair.baseToken.address
        const vol = pair.volume?.h24 || 0

        // Keep the pair with highest 24h volume for most accurate price
        if (!bestPrices[addr] || vol > bestPrices[addr].volume) {
          bestPrices[addr] = { price, volume: vol }
        }
      }

      for (const [addr, { price }] of Object.entries(bestPrices)) {
        prices[addr] = price
      }
    } catch (error) {
      console.error('[DexScreener] Fetch error:', error)
    }
  }

  return prices
}

/**
 * Fetch prices for multiple symbols using DexScreener.
 * Uses hardcoded mint addresses for instant lookup.
 * Returns a map of symbol -> { price, address }
 */
export async function fetchJupiterPrices(
  symbols: string[]
): Promise<Record<string, { price: number; address: string }>> {
  const result: Record<string, { price: number; address: string }> = {}

  const addressToSymbol: Record<string, string> = {}
  const addresses: string[] = []

  for (const symbol of symbols) {
    const upper = symbol.toUpperCase()
    if (upper === 'USDC') {
      result['USDC'] = { price: 1.0, address: KNOWN_MINTS['USDC'] || '' }
      continue
    }
    if (upper === 'USDT') {
      result['USDT'] = { price: 1.0, address: KNOWN_MINTS['USDT'] || '' }
      continue
    }
    const mint = KNOWN_MINTS[upper]
    if (mint) {
      addressToSymbol[mint] = upper
      addresses.push(mint)
    }
  }

  if (addresses.length === 0) return result

  // Batch fetch from DexScreener
  const prices = await fetchDexScreenerPrices(addresses)

  // Map back to symbols
  for (const [address, price] of Object.entries(prices)) {
    const symbol = addressToSymbol[address]
    if (symbol) {
      result[symbol] = { price, address }
    }
  }

  console.log('[DexScreener] Fetched ' + Object.keys(result).length + '/' + symbols.length + ' token prices')
  return result
}

/**
 * Get the known mint address for a symbol, if we have it
 */
export function getMintAddress(symbol: string): string | undefined {
  return KNOWN_MINTS[symbol.toUpperCase()]
}

/**
 * Fetch prices with source tracking
 */
export async function fetchPricesWithFallback(
  symbols: string[]
): Promise<Record<string, { price: number; source: 'jupiter' | 'coingecko' | 'fallback' }>> {
  const result: Record<string, { price: number; source: 'jupiter' | 'coingecko' | 'fallback' }> = {}

  const dexPrices = await fetchJupiterPrices(symbols)

  for (const [symbol, data] of Object.entries(dexPrices)) {
    result[symbol] = { price: data.price, source: 'jupiter' }
  }

  return result
}

/**
 * Clear the token cache (no-op now, kept for compatibility)
 */
export function clearTokenCache(): void {
  // No cache to clear with DexScreener approach
}
